/** Reset the actual admin scroll owners, including nested content panels, without scrolling the table itself. */
export function pageScrollOwners(root: HTMLElement | null): HTMLElement[] {
  const owners: HTMLElement[] = [];
  for (let el = root?.parentElement; el; el = el.parentElement) {
    if (/auto|scroll/.test(getComputedStyle(el).overflowY)) owners.push(el);
  }
  if (document.scrollingElement && !owners.includes(document.scrollingElement as HTMLElement)) {
    owners.push(document.scrollingElement as HTMLElement);
  }
  return owners;
}

export function resetPageScroll(root: HTMLElement | null): boolean {
  pageScrollOwners(root).forEach((el) => {
    // Direct writes bypass smooth-scroll styling and happen before navigation / paint.
    el.scrollTop = 0;
    el.scrollLeft = 0;
  });
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  return pageScrollOwners(root).every((el) => el.scrollTop === 0);
}
